export default class AddedRatesModifier {
    constructor(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }

    modify(content) {
        if (content.rates === undefined || content.rates.add === undefined) {
            return;
        }

        const rates = content.rates.add;

        for (let i = 0; i < rates.length; i++) {
            const rate = rates[i];

            const key = this._modelKeyRepository.addRate(rate.o, rate.id);

            rates[i] = Object.assign({
                type: rate.t,
                value: rate.v
            }, key);
        }
    }
}



// WEBPACK FOOTER //
// ./js/repositories/modifier/AddedRatesModifier.js